var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegenerateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28286_12230)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.41992 8.00187C2.41992 4.92026 4.9183 2.42188 7.99992 2.42188C9.66552 2.42188 11.1612 3.15151 12.1841 4.30984C12.2937 4.43392 12.202 4.62203 12.0365 4.62203H10.5599C10.2838 4.62203 10.0599 4.84588 10.0599 5.12203C10.0599 5.39817 10.2838 5.62203 10.5599 5.62203H13.7399C13.8504 5.62203 13.9399 5.53248 13.9399 5.42202V2.24202C13.9399 1.96588 13.716 1.74202 13.4399 1.74202C13.1638 1.74202 12.9399 1.96588 12.9399 2.24202V3.12543C12.9399 3.30979 12.7068 3.4002 12.5743 3.27203C11.3905 2.12699 9.77773 1.42188 7.99992 1.42188C4.36602 1.42188 1.41992 4.36797 1.41992 8.00187C1.41992 8.27802 1.64378 8.50187 1.91992 8.50187C2.19606 8.50187 2.41992 8.27802 2.41992 8.00187ZM5.43995 10.3824L2.25992 10.382C2.14945 10.382 2.0599 10.4716 2.0599 10.582V13.7621C2.0599 14.0382 2.28375 14.2621 2.5599 14.2621C2.83604 14.2621 3.0599 14.0382 3.0599 13.7621V12.878C3.0599 12.6936 3.29304 12.6032 3.42554 12.7314C4.60926 13.8766 6.2221 14.582 8.00016 14.582C11.6341 14.582 14.5802 11.6359 14.5802 8.00195C14.5802 7.72581 14.3563 7.50195 14.0802 7.50195C13.804 7.50195 13.5802 7.72581 13.5802 8.00195C13.5802 11.0836 11.0818 13.582 8.00016 13.582C6.33469 13.582 4.83924 12.8524 3.81646 11.6944C3.70687 11.5703 3.79861 11.3822 3.96416 11.3822L5.43984 11.3824C5.71598 11.3824 5.93987 11.1586 5.9399 10.8824C5.93993 10.6063 5.71609 10.3824 5.43995 10.3824Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28286_12230"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegenerateIcon);
export default __webpack_public_path__ + "static/media/RegenerateIcon.8ba457b799dffeb1f5725fe483fdb2ca.svg";
export { ForwardRef as ReactComponent };